import { render, staticRenderFns } from "./watchOrder.vue?vue&type=template&id=7789649a&scoped=true&"
import script from "./watchOrder.vue?vue&type=script&lang=ts&"
export * from "./watchOrder.vue?vue&type=script&lang=ts&"
import style0 from "./watchOrder.vue?vue&type=style&index=0&id=7789649a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789649a",
  null
  
)

export default component.exports